/**
 * PR-D4-035 — Root landing page with Google OAuth provider.
 * Authentic MadCrab_V LoginLanding shell; CTA → Google Sign-In → /dashboard.
 */

import { useNavigate } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import LoginLanding from '../madcrab/LoginLanding.jsx';

const GOOGLE_CLIENT_ID =
    import.meta.env.VITE_GOOGLE_CLIENT_ID ||
    '563979537967-qjh41c1h3dl7vmfgqi34eljef4pkc1iq.apps.googleusercontent.com';

export function LandingPage() {
    const navigate = useNavigate();

    return (
        <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
            <LoginLanding
                onSuccess={() => {
                    navigate('/dashboard');
                }}
            />
        </GoogleOAuthProvider>
    );
}
